import {authorized} from "./ApiClient";
import {SiteStatHit, SiteStatMarker, SiteStatMarkerInput, SiteStatsReport} from "./models";

export const StatsApi = {
    // Fire and forget: never fails, and never waits for an answer. text/plain makes it a simple CORS request (no
    // preflight); the API reads the body as JSON whatever its type. keepalive: it still goes when the page is leaving.
    hit: async (hit: SiteStatHit): Promise<void> => {
        try {
            await fetch(`${API_BASE}/stats/hit`, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(hit), keepalive: true });
        } catch {
            // Not counted.
        }
    },

    // The visit counts and each product's funnel (SiteAdmin), for days from and to (YYYY-MM-DD, UTC, both included).
    report: (from: string, to: string) =>
        authorized<SiteStatsReport>('GET', `/stats?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`),

    // Named days in the counts (SiteAdmin), latest first.
    markers: () => authorized<SiteStatMarker[]>('GET', '/stats/markers'),
    addMarker: (marker: SiteStatMarkerInput) => authorized<SiteStatMarker>('POST', '/stats/markers', marker),
    changeMarker: (id: string, marker: SiteStatMarkerInput) =>
        authorized<SiteStatMarker>('PUT', `/stats/markers/${encodeURIComponent(id)}`, marker),
    deleteMarker: (id: string) => authorized<void>('DELETE', `/stats/markers/${encodeURIComponent(id)}`)
};
